import HighchartsReact from 'highcharts-react-official';
import { useReportingContext } from 'modules/iterableGoals/contexts';

import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { GoalPerformanceChartProps } from 'modules/iterableGoals/types';
import { getHighchartOptions } from 'modules/iterableGoals/utils';

import { ChartWrapper } from './Styled';

export const GoalPerformanceChart = ({ graphData, innerRef }: GoalPerformanceChartProps) => {
  const { t } = useGoalsTranslations();
  const { isRevenue, getReportingTranslation } = useReportingContext();

  return (
    <ChartWrapper>
      <HighchartsReact
        options={getHighchartOptions(graphData, t, getReportingTranslation, isRevenue)}
        ref={innerRef}
        containerProps={{ style: { width: '100%', height: '100%' } }}
      />
    </ChartWrapper>
  );
};
